'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _feedUserType = require('../shared/feed-user-type');

var _feedUserType2 = _interopRequireDefault(_feedUserType);

var _highlightOwnerType = require('../shared/highlight-owner-type');

var _highlightOwnerType2 = _interopRequireDefault(_highlightOwnerType);

var _constants = require('../shared/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultAvatar = '//sc.hudl.com/images/thumb-user.svg';
var defaultMarketingAccountId = '54ca65d70c794407b83085e9';

var unknownImageSizePreference = 5;
var imageSizeToPreference = {
  0: 2, // Normal
  1: 1, // Thumbnail
  2: 3, // Retina
  3: 4 // Full
};

function getSizePreference(image) {
  return imageSizeToPreference[image.size] || unknownImageSizePreference;
}

function getFeedUserAvatar(feedUser) {
  if (!feedUser || !feedUser.profileImages || !feedUser.profileImages.length) {
    return null;
  }

  var smallestImage = void 0;
  feedUser.profileImages.forEach(function (image) {
    if ((!smallestImage || getSizePreference(image) < getSizePreference(smallestImage)) && image.url) {
      smallestImage = image;
    }
  });

  return smallestImage && smallestImage.url || null;
}

function getFeedUserName(feedUser) {
  if (!feedUser || !feedUser.nameComponents) {
    if (feedUser && feedUser.name) {
      return feedUser.name;
    }

    return null;
  }

  switch (feedUser.feedUserId.type) {
    case _feedUserType2.default.User:
      var firstName = feedUser.nameComponents.f;
      var lastName = feedUser.nameComponents.l;
      if (!lastName) return firstName;
      if (!firstName) return lastName;
      return firstName + ' ' + lastName;

    case _feedUserType2.default.Team:
      var teamName = feedUser.nameComponents.t;
      var schoolName = feedUser.nameComponents.s;
      var fullName = (schoolName + ' - ' + teamName).replace('High School ', '').replace('Boys ', '').replace('Girls ', '');
      return fullName;

    default:
      return feedUser.nameComponents.n;
  }
}

function getFeedUserInitials(name) {
  return name ? name.split(' ').map(function (n) {
    return n[0];
  }).join('') : '';
}

function getHighlightOwnerType(feedUserType) {
  switch (feedUserType) {
    case _feedUserType2.default.User:
      return _highlightOwnerType2.default.User;
    case _feedUserType2.default.Team:
      return _highlightOwnerType2.default.Team;
    case _feedUserType2.default.Hudl:
      return _highlightOwnerType2.default.Hudl;
    default:
      return _highlightOwnerType2.default.Unknown;
  }
}

function shouldShowFollowButton() {
  var currentUserId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.ANONYMOUS_USER_ID;
  var author = arguments[1];
  var targetCriteria = arguments[2];

  var isMarketingAccount = author.type === _feedUserType2.default.Hudl && author.relatedId === defaultMarketingAccountId;
  var isCurrentUser = author.type === _feedUserType2.default.User && author.relatedId === currentUserId;
  var isLoggedIn = currentUserId && currentUserId !== _constants.ANONYMOUS_USER_ID;

  return !!(targetCriteria && !isMarketingAccount && isLoggedIn && !isCurrentUser);
}

exports.default = {
  defaultAvatar: defaultAvatar,
  getFeedUserAvatar: getFeedUserAvatar,
  getFeedUserName: getFeedUserName,
  getFeedUserInitials: getFeedUserInitials,
  getHighlightOwnerType: getHighlightOwnerType,
  shouldShowFollowButton: shouldShowFollowButton
};